import React, { useEffect, useState } from 'react'
import { Dialog, Button } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { Auth } from 'aws-amplify'
import PasswordTextValidator from '../PasswordTextValidator'
import PasswordRequirements from '../PasswordRequirements'
import { ValidatorForm } from 'react-material-ui-form-validator'
import { toast } from 'react-toastify'

const NewPasswordDialog = ({ open, onClose, onSuccess, user }) => {
  const [loading, setLoading] = useState(false)
  const [newPassword, setNewPassword] = useState('')

  useEffect(() => {
    setNewPassword('')
  }, [open])

  const handleFormSubmit = async () => {
    if (loading || !newPassword) return
    setLoading(true)
    try {
      const cognitoUser = await Auth.completeNewPassword(user, newPassword)
      onSuccess(cognitoUser)
    } catch (error) {
      toast.error(error?.message || 'Something went wrong! Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog maxWidth="xs" open={open} onClose={onClose}>
      <h4 className="capitalize m-0 mb-4">New Password Required</h4>
      <ValidatorForm onSubmit={handleFormSubmit}>
        <div>
          <PasswordTextValidator
            className="w-full mb-3"
            label="New Password"
            onChange={(e) => setNewPassword(e.target.value)}
            name="password"
            value={newPassword}
          />
          <PasswordRequirements password={newPassword} />
        </div>
        <div className="flex justify-start pt-3 m--2">
          <Button
            className="m-2 rounded hover-bg-primary px-6"
            variant="outlined"
            color="primary"
            disabled={loading || !newPassword}
            type={'submit'}
            startIcon={loading ? <CircularProgress size={16} /> : null}
          >
            Submit
          </Button>
          <Button
            className="m-2 rounded hover-bg-error px-6"
            variant="outlined"
            onClick={onClose}
          >
            Cancel
          </Button>
        </div>
      </ValidatorForm>
    </Dialog>
  )
}

export default NewPasswordDialog
